import {SearchInput} from "@ergeon/erg-components-react";
import React, {Component} from "react";
import PropTypes from "prop-types";

import {isDesktop} from "utils";
import styles from "v2/styles";

export default class RoutesSearchBox extends Component {
  static contextTypes = {
    location: PropTypes.object,
    router: PropTypes.object,
  }
  static defaultProps = {
    noFocus: false,
    placeholder: "Filter by gardener or type",
  }
  static propTypes = {
    noFocus: PropTypes.bool,
    placeholder: PropTypes.string,
  }

  handleSearch = (value) => {
    const {location: {pathname, query}, router} = this.context;
    const newQuery = {...query, q: value ? value : undefined};
    router.push({
      pathname,
      query: newQuery,
    });
  }

  render() {
    const {location: {query: {q: search}}} = this.context;
    const {noFocus, placeholder} = this.props;

    const focusSearchBox = (el) => {
      if (el && isDesktop() && !noFocus) {
        el.searchInput.focus();
      }
    };

    return (
      <div
        className="erg-padding-15 erg-margin-bottom-0"
        style={{
          backgroundColor: styles.COLOR.BG_LIGHTGREY,
          borderBottom: styles.BORDER,
        }}>
        <SearchInput
          inputClassName="form-control input-sm"
          onSearch={this.handleSearch}
          placeholder={placeholder}
          ref={focusSearchBox}
          value={search || ""} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RoutesSearchBox.js
 **/